export default "__VITE_ASSET__BCIAAVKH__"